import { useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import ScrollNav from "../../components/ScrollNav/ScrollNav";
import CategorySection from "../../components/CategorySection/CategorySection";
import Footer from "../../components/Footer/Footer";
import BookmarksBar from "../../components/BookmarksBar/BookmarksBar";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import { getBookmarks } from "../../utils/bookmarksHelper";
import {
  drinksData,
  dessertsData,
  footerContent,
} from "../../config/textContent";
import "./CategoryPage.css";

const CategoryPage = () => {
  const { categoryId } = useParams();
  const [isBookmarksExpanded, setIsBookmarksExpanded] = useState(false);
  const [hasBookmarks, setHasBookmarks] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const categoryData = categoryId === "drinks" ? drinksData : dessertsData;

  // Check if bookmarks exist
  useEffect(() => {
    const checkBookmarks = () => {
      const bookmarks = getBookmarks();
      setHasBookmarks(bookmarks.length > 0);
    };

    // Initial check
    checkBookmarks();

    // Listen for bookmark changes
    window.addEventListener("bookmarksChanged", checkBookmarks);
    window.addEventListener("storage", checkBookmarks);

    return () => {
      window.removeEventListener("bookmarksChanged", checkBookmarks);
      window.removeEventListener("storage", checkBookmarks);
    };
  }, []);

  useEffect(() => {
    // Simulate data loading and image preloading
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 500);

    return () => clearTimeout(timer);
  }, [categoryId]);

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!categoryData) {
    return <div>Категорію не знайдено</div>;
  }

  const handleBookmarksToggle = (expanded) => {
    setIsBookmarksExpanded(expanded);
  };

  return (
    <div className="category-page">
      <ScrollNav
        categories={categoryData.categories}
        pageTitle={categoryData.pageTitle}
      />

      <main className="category-main">
        {categoryData.categories.map((category) => (
          <CategorySection key={category.id} category={category} />
        ))}
      </main>

      <Footer
        address={footerContent.address}
        phone={footerContent.phone}
        email={footerContent.email}
        mapLink={footerContent.mapLink}
        socialLinks={footerContent.socialLinks}
        companyName={footerContent.companyName}
        workingHours={footerContent.workingHours}
        hasBookmarksBar={hasBookmarks}
        isBookmarksExpanded={isBookmarksExpanded}
      />

      <BookmarksBar onToggle={handleBookmarksToggle} />
    </div>
  );
};

export default CategoryPage;
